import Ghost from 'react-loading-skeleton';
import { Layout } from '../Layout';

export const Skeleton = ({ children }: {children: any}) => (
	<Layout
		icon={<Ghost circle width={40} height={40} />}
		modifiers={
			<>
				<Ghost style={{ lineHeight: 0.7 }} height={12.8} width={43} />{' '}
				<Ghost style={{ lineHeight: 0.7 }} height={12.8} width={65} />
			</>
		}
		name={
			<>
				<Ghost style={{ lineHeight: 0.7 }} height={16} width={35} />{' '}
				<Ghost style={{ lineHeight: 0.7 }} height={16} width={85} />{' '}
				<Ghost style={{ lineHeight: 0.7 }} height={16} width={55} />
			</>
		}
		price={<Ghost width={35} />}
		id={<Ghost width={0} />}
	>
		{children}
	</Layout>
);
